/**
 * The components every site renders AROUND its app — identical on the server and in
 * the browser, because `useId` depends on it.
 *
 * 🔴 WHY THIS IS ONE COMPONENT USED TWICE. `mountClient` rendered
 * `<ScrollReset/>{app}<PageviewTracker/>` while `createRenderBody` rendered `{app}`
 * alone. Both extra components render nothing, so the MARKUP matched — but React's
 * `useId` is derived from a component's position among its siblings, so every id
 * under the app differed between the two renders. Any component that writes a
 * `useId` into its output then fails hydration: the shared figure gallery's
 * generated grid class came back `gallery-figure-R2r` from the server and
 * `gallery-figure-r0` from the browser (React #425 then #422, the section
 * client-rendered), found migrating Holy Trinity's gallery on dev, 2026-09-13.
 * A frame both sides import cannot drift that way.
 */
import type { ReactNode } from 'react'
import { ScrollReset } from './scroll-reset'
import { PageviewTracker } from './pageview-tracker'

export function SiteFrame({ children }: { children: ReactNode }) {
  // PageviewTracker LAST — see pageview-tracker.tsx for why the order is load-bearing.
  return (
    <>
      <ScrollReset />
      {children}
      <PageviewTracker />
    </>
  )
}
